import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 2C4.692 2 2 4.692 2 8c0 3.309 2.692 6 6 6 .027 0 .053-.003.08-.003l-.893.892.707.708 1.871-1.873h.001l.249-.25-.665-.664-1.456-1.457-.707.708.931.93C8.078 12.992 8.04 13 8 13c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5a5.003 5.003 0 01-2.64 4.405l.729.729A5.996 5.996 0 0014 8c0-3.308-2.692-6-6-6z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3c-4.962 0-9 4.038-9 9 0 4.963 4.038 9 9 9 .04 0 .079-.004.119-.005l-1.339 1.339 1.061 1.061 2.807-2.809h.001l.373-.374-.997-.997-2.184-2.185-1.061 1.061 1.397 1.396c-.06.001-.117.013-.177.013-4.136 0-7.5-3.364-7.5-7.5S7.864 4.5 12 4.5s7.5 3.364 7.5 7.5a7.504 7.504 0 01-3.959 6.608l1.092 1.093C19.244 18.124 21 15.268 21 12c0-4.962-4.038-9-9-9z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 6C14.076 6 6 14.076 6 24c0 9.926 8.076 18 18 18 .08 0 .158-.008.238-.01l-2.678 2.678 2.122 2.122 5.614-5.618h.002l.746-.748-1.994-1.994-4.368-4.37-2.122 2.122 2.794 2.792c-.12.002-.234.026-.354.026-8.272 0-15-6.728-15-15S15.728 9 24 9s15 6.728 15 15c0 5.71-3.21 10.686-7.918 13.216l2.184 2.186C38.488 36.248 42 30.536 42 24c0-9.924-8.076-18-18-18z",
    clipRule: "evenodd"
  }))
};
export var Replay = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});